document.addEventListener('DOMContentLoaded', () => {
	const modal = document.getElementById('subscribe-modal');
	const trigger = document.getElementById('footer-cta');
	const closeButton = document.getElementById('subscribe-modal-close');
	const formContent = document.getElementById('subscribe-modal-form-content');
	const successContent = document.getElementById('subscribe-modal-success');

	if (!modal || !trigger || !closeButton) {
		return;
	}

	const focusableSelector = [
		'a[href]',
		'button:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join(',');

	let activeTrigger = null;
	let previousBodyOverflow = '';

	function getFocusableElements() {
		return Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
			return element.offsetParent !== null || element === closeButton;
		});
	}

	function openModal(event) {
		event.preventDefault();

		activeTrigger = document.activeElement;
		previousBodyOverflow = document.body.style.overflow;

		modal.classList.remove('hidden');
		modal.classList.add('flex');
		modal.setAttribute('aria-hidden', 'false');
		trigger.setAttribute('aria-expanded', 'true');
		document.body.style.overflow = 'hidden';

		closeButton.focus();
	}

	function closeModal() {
		modal.classList.add('hidden');
		modal.classList.remove('flex');
		modal.setAttribute('aria-hidden', 'true');
		trigger.setAttribute('aria-expanded', 'false');
		document.body.style.overflow = previousBodyOverflow;

		if (activeTrigger && typeof activeTrigger.focus === 'function') {
			activeTrigger.focus();
		}
	}

	function handleOverlayClick(event) {
		if (event.target === modal) {
			closeModal();
		}
	}

	function handleKeydown(event) {
		if (modal.classList.contains('hidden')) {
			return;
		}

		if (event.key === 'Escape') {
			event.preventDefault();
			closeModal();
			return;
		}

		if (event.key !== 'Tab') {
			return;
		}

		const focusableElements = getFocusableElements();

		if (!focusableElements.length) {
			event.preventDefault();
			return;
		}

		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		if (event.shiftKey && document.activeElement === firstFocusable) {
			event.preventDefault();
			lastFocusable.focus();
		}

		if (!event.shiftKey && document.activeElement === lastFocusable) {
			event.preventDefault();
			firstFocusable.focus();
		}
	}

	function handleSuccess(event) {
		if (!event.form || !modal.contains(event.form)) {
			return;
		}

		if (!formContent || !successContent) {
			return;
		}

		if (event.type === 'freeform-render-success') {
			event.preventDefault();
		}

		formContent.classList.add('hidden');
		successContent.classList.remove('hidden');
		successContent.classList.add('flex');
	}

	trigger.addEventListener('click', openModal);
	closeButton.addEventListener('click', closeModal);
	modal.addEventListener('click', handleOverlayClick);
	document.addEventListener('freeform-ajax-success', handleSuccess);
	document.addEventListener('freeform-render-success', handleSuccess);
	document.addEventListener('keydown', handleKeydown);
});
